define('InputPhoneView',['underscore','jquery','backbone','phoneUtils','app','SelectView'], function (_,$,Backbone,phoneUtils,app,SelectView) {

    var InputPhoneView = Backbone.View.extend({
        events: {
            'blur': 'update',
            'blur .input-field': 'updateInput',
            'keyup .input-field': 'updateInput',
            'change .input-field': 'updateInput'
        },
        initialize: function(){
            this.render();
        },
        render:function(){
            var view = this,
                regions =  phoneUtils.getSupportedRegions(),
                inputField = view.$('.input-field'),
                phone = inputField.val(),
                initialCountryCode = phoneUtils.getRegionCodeForNumber(phone),
                shortCountryListGroup = [],
                otherCountryListGroup = [];

            // prevent InputView instanciation
            view.isInputView = true;

            _(regions).each(function(item){
                if(!item.country) return;
                var emoji = item.emoji,
                    code = item.code,
                    label = (emoji ? emoji+' ':'')+item.name,
                    selected = initialCountryCode === code ? " selected":"",
                    selectOptions = item.shortListed ? shortCountryListGroup : otherCountryListGroup;
                selectOptions.push('<option value="'+code+'" data-tokens="'+code+'" '+selected+'>'+label+'</option>');
            });

            function groupOptions(options, label){
                if(label){
                    label = ' label="'+label+'"';
                }else{
                    label = '';
                }
                return "<optgroup "+label+">"+options.join('')+"</optgroup>"
            }

            view.$('select.input-phone__select').attr('data-size',shortCountryListGroup.length+1.25).html(
                groupOptions(shortCountryListGroup)
                +groupOptions(otherCountryListGroup)
            );

            var selectView = SelectView.initializeSelectsOfView(view)[0];
            if(!selectView){
                selectView = view.$('.selectpicker').data('view');
                selectView.refreshSelect();
            }
            view.selectView = selectView;

            view.$('.dropdown-menu li a').each(function(i,el){
                var $el = $(el), code = $el.data('tokens');
                if(code){
                    $el.prepend('<span class="flag-icon flag-icon-'+code.toLowerCase()+'"></span>');
                }else{
                }
            });

            view.listenTo(selectView,'change',view.onChangeCountry);

            view.updateCountryCode(initialCountryCode);

        },
        updateCountryCode:function(code){
            var view = this;
            if(!code || code.length === 0){
                code = 'FR';
            }
            view.code = code;
            var prefix = phoneUtils.getCodeForRegion(code);
            view.$('.input-phone__regions-preview').html('<div class="flag-icon flag-icon-'+code.toLowerCase()+'"></div><span class="phone-prefix">(+'+prefix+')</span>');
            view.updateInput();
        },
        updateInput:function(e) {
            var view = this,
                field = view.$('.input-field'),
                phoneNumber = field.val(),
                code = view.code,
                phoneNumberMetas = phoneUtils.inspectPhoneNumber(phoneNumber, code),
                phoneCountryCode = phoneNumberMetas.phoneCountryCode,
                E164 = phoneNumberMetas.E164,
                applyE164 = false;
            //
            field.data('E164',E164);
            //
            if(phoneNumberMetas.success){
                field.val(phoneNumberMetas.formatted);
                applyE164 = phoneNumberMetas.formatted !== phoneNumber && phoneNumber!==E164;
            }
            if(applyE164){
                field.val(E164);
                view.selectView.val(phoneCountryCode);
                view.updateCountryCode(phoneCountryCode);
            }
            // filled state
            var ua = navigator.userAgent.toLowerCase(); // User Agent
            if(ua.indexOf('chrome') > -1 || ua.indexOf('safari') > -1 || ua.indexOf('mozilla') > -1) {
                view.$el.toggleClass('input-filled',phoneNumber != '');
            }

        },
        onChangeCountry:function(e,code){
            this.updateCountryCode(code);
        }


    });

    InputPhoneView.initializeInputsOfView = function(view){
        var views = [];
        view.$('.input-phone').each(function(){
            if(!this.isInputView) views.push(new InputPhoneView({el:this}));
        });
        return views;
    };

    return InputPhoneView;

});

